<template>
  <LibraryListItem>
    <ReqTitleCell :title="title" :on-hold="onHold" />
    <ReqIdCell :ats-req-id="atsReqId" />
    <ReqDepartmentCell :department-name="departmentName" />
    <ReqHiringManagerCell :hiring-managers="hiringManagers" />
  </LibraryListItem>
</template>

<script setup>
import LibraryListItem from '@/components/shared/LibraryListItem.vue';
import ReqTitleCell from '@/components/requisitions/listItemCells/ReqTitleCell.vue';
import ReqIdCell from '@/components/requisitions/listItemCells/ReqIdCell.vue';
import ReqDepartmentCell from '@/components/requisitions/listItemCells/ReqDepartmentCell.vue';
import ReqHiringManagerCell from '@/components/requisitions/listItemCells/ReqHiringManagerCell.vue';

defineProps({
  title: {
    type: String,
    default: '',
  },
  onHold: {
    type: Boolean,
    default: false,
  },
  atsReqId: {
    type: String,
    default: '',
  },
  departmentName: {
    type: String,
    default: '',
  },
  hiringManagers: {
    type: Array,
    default: () => [],
  },
});
</script>

<style lang="less" scoped>
</style>
